<template>
  <div>
    <SwapDevice
      v-if="openSwap"
      :show="openSwap"
      v-on:closeSwap="openSwap = false"
      v-on:showMsg="showMsg"
    />
    <ConfirmModal
      :msg="$t('confirm_export', { date })"
      :show="showConfirm"
      :heading="$t('export_history')"
      :btnTxt="$t('yes_export')"
      @close="showConfirm = false"
      @submit="exportReport"
      is-yellow
    />

    <timezone
      :show="show_time"
      @openExport="openExport"
      @close="show_time = false"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      :msg="$t('email_dev_history', { email })"
      :heading="$t('check_email')"
      is-export
    />

    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div class="page-wrapper">
      <div class="page-breadcrumb sticky-breadcrumb">
        <div class="row">
          <div class="col-md-5 align-self-center col-sm-4 col-12">
            <ul class="breadcrumb mb-2 list-style-none">
              <li
                class="breadcrumb-item h6 font-16 mylink"
                style="margin-right: 3rem"
              >
                <router-link
                  class="mylink"
                  :to="'/devices/' + this.$route.params.device_id + '/details'"
                  >{{ $t("details") }}</router-link
                >
              </li>
              <li
                class="breadcrumb-item h6 font-16 mylink"
                style="margin-right: 3rem"
              >
                <router-link
                  class="mylink"
                  :to="
                    '/devices/' + this.$route.params.device_id + '/excursions'
                  "
                  >{{ $t("excursions") }}</router-link
                >
              </li>
              <li
                class="breadcrumb-item h6 font-16 mylink"
                style="margin-right: 3rem"
              >
                <router-link
                  class="mylink"
                  :to="'/devices/' + this.$route.params.device_id + '/settings'"
                  >{{ $t("settings") }}</router-link
                >
              </li>
            </ul>
          </div>
          <div
            class="col-md-7 align-self-center col-sm-8 col-12"
            v-if="singledevice"
          >
            <div
              class="date-export align-items-center justify-content-end py-2"
            >
              <date-component
                class="mr-4 date"
                @period="handlePeriodChange"
                v-if="this.$route.name == 'DeviceDetails'"
              />
              <button
                class="btn btn-secondary mr-3"
                @click="show_time = true"
                :disabled="!startdate && !enddate"
                v-if="this.$route.name == 'DeviceDetails'"
              >
                {{ $t("export") }}
              </button>

              <button class="btn btn-primary nowrap" @click="openSwap = true">
                {{ $t("device_swap") }}
              </button>
            </div>
          </div>
        </div>

        <!-- <NotificationBox
          :mssg="successMsg"
          :errorMssg="errorMssg"
          v-if="successMsg || errorMssg"
        /> -->
      </div>

      <router-view :singledevice="singledevice" @pageChange="pageChange" />

      <footer class="footer text-center">
        &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SwapDevice from "../Modals/SwapDevice.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import DateComponent from "../../components/DateComponent.vue";
import ConfirmModal from "../Modals/ConfirmModal.vue";
import SuccessModal from "../Modals/SuccessModal.vue";
import Timezone from "../Modals/Timezone.vue";

export default {
  name: "ViewDevice",
  data() {
    return {
      isLoading: true,
      fullPage: true,
      openSwap: false,
      successMsg: "",
      errorMssg: "",
      startdate: "",
      enddate: "",
      params: {
        limit: 10,
        page: 1,
      },
      showConfirm: false,
      showSuccessPopup: false,
      show_time: false,
    };
  },
  components: {
    Loading,
    SwapDevice,
    // NotificationBox,
    DateComponent,
    ConfirmModal,
    SuccessModal,
    Timezone,
  },
  mounted() {
    this.fetchDeviceDetails({ device_id: this.$route.params.device_id })
      .then(() => {
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        if (error.response) {
          //console.log(error.response);
          this.$router.push("/404");
        }
      });

    // this.gethistory({ pageSize: { limit: 10, page: 1 } });
  },
  computed: {
    ...mapGetters(["profile", "singledevice", "currentTimezone"]),
    date() {
      return `${moment(this.startdate).format("DD/MM/YY")} - ${moment(
        this.enddate
      ).format("DD/MM/YY")}`;
    },
    email() {
      return this.profile.email;
    },
  },
  methods: {
    ...mapActions([
      "fetchDeviceDetails",
      "getDeviceHistory",
      "getDeviceHistoryChart",
      "getDeviceHistoryMapPoints",
      "getDeviceReportByEmail",
      "resetHistoryChart",
    ]),
    showMsg() {
      this.mssg = "";
      setTimeout(() => {
        this.mssg = "";
      }, 4000);
    },
    exportReport() {
      this.isLoading = true;
      const id = this.$route.params.device_id;
      const data = {
        email: this.profile.email,
        startDate: this.startdate || undefined,
        endDate: this.enddate || undefined,
        timeZone: this.currentTimezone,
      };
      this.getDeviceReportByEmail({ data, id })
        .then((res) => {
          // this.successMsg = res.data.payload.message;
          this.isLoading = false;
          this.showSuccessPopup = true;
          this.showConfirm = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.isFilter = false;
          // this.Errormssg =
          //   error.response.data.message[0].toUpperCase() +
          //   error.response.data.message.slice(1);
          // // error.response can be null
          setTimeout(() => {
            this.errorMssg = "";
          }, 10000);
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    pageChange(params) {
      this.isLoading = true;
      let startDate = `${this.startdate}`;
      let endDate = `${this.enddate}`;
      this.params = params;
      this.gethistory({ endDate, startDate, pageSize: params });
    },
    gethistory({ endDate, startDate, pageSize }) {
      let period = {
        device: this.$route.params.device_id,
      };
      const params = {
        ...pageSize,
        startDate: startDate ? startDate : undefined,
        endDate: endDate ? endDate : undefined,
        filterOperator: "and",
      };
      this.resetHistoryChart();
      this.getDeviceHistory({ period, params }).then(
        () => (this.isLoading = false)
      );
      this.getDeviceHistoryChart({ period, params });
      this.getDeviceHistoryMapPoints({
        period,
        params: { endDate: params.endDate, startDate: params.startDate },
      });
    },
    handlePeriodChange({ startdate, enddate }) {
      this.startdate = startdate;
      this.enddate = enddate;
      if (startdate && enddate) {
        this.isLoading = true;
        this.gethistory({
          endDate: enddate,
          startDate: startdate,
          pageSize: this.params,
        });
      }
    },
    openExport() {
      this.show_time = false;
      this.showConfirm = true;
    },
  },
};
</script>

<style scoped>
.mylink {
  color: #213e7a !important;
  font-size: 14px !important;
  text-decoration-color: #213e7a !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-color: #213e7a !important;
}
.router-link-exact-active.router-link-active {
  text-decoration: underline !important;
  color: #213e7a !important;
  cursor: default;
  text-underline-offset: 5px;
}
.swap {
  background-color: white !important;
  border-color: #213e7a !important;
  color: #213e7a !important;
}
.date-export {
  display: flex;
}

.sticky-breadcrumb{
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: rgba(249, 250, 251, 1);
}

@media (max-width: 500px) {
  .date-export {
    display: block;
  }

  .date {
    margin-bottom: 20px;
  }
}
</style>
